module.exports = __webpack_public_path__ + "media/images/proof_links/colored/wildberries-14f8f6c818b4884df938736bea9e51d1.svg";